export default __webpack_public_path__ + "static/B204-88af09ff6ec040bbcac743432ad1532f.jpg";